import { toCoordinates } from '@utils/validation/coordinates.utils';
import { MapMouseEvent, Point } from 'mapbox-gl';
import { useEffect, useState } from 'react';
import { useMap } from 'react-map-gl/mapbox';

import { NullableCoordinates } from '@/types/commons/commons.types';

type CursorPosition = {
  point: Point;
  lngLat: NullableCoordinates;
};

export const useMapCursorPosition = () => {
  const { current: map } = useMap();
  const [cursorPosition, setCursorPosition] = useState<CursorPosition | null>(null);

  useEffect(() => {
    if (!map) return;

    const handleMouseMove = (e: MapMouseEvent) => {
      const lngLat = toCoordinates(e.lngLat);
      if (lngLat) {
        setCursorPosition({ point: e.point, lngLat });
      }
    };

    map.on('mousemove', handleMouseMove);

    return () => {
      map.off('mousemove', handleMouseMove);
    };
  }, [map]);

  return { cursorPosition };
};
